import { SearchResultMeta } from './search/search-result-meta.model';
import { SearchResultRequest } from './search/search-result-request.model';
import { SearchResultFacet } from './search/search-result-facet.model';
import { SearchResultsDto } from './search-results-dto.model';

export class SearchResultsContainer<T> {
  public data: T[] = [];
  public facets: SearchResultFacet[] = [];
  public request: SearchResultRequest;
  public meta: SearchResultMeta;

  constructor(searchResultsDto: SearchResultsDto<T>) {
    this.data = searchResultsDto.data;
    this.facets = searchResultsDto.facets;
    this.request = searchResultsDto.request;
    this.meta = searchResultsDto.meta;
  }
}
